import axios from "axios";

// const url = 'http://localhost:5000';
const url = process.env.REACT_APP_API_URL_DASHBOARD;

export default class DashboardService {

    getCount(startDate, endDate, sts_checklist = null) {
        return axios.get(url + '/tr_oss_checklist_count', {
            params: {
                startDate,
                endDate,
                ...(sts_checklist && {
                    sts_checklist
                }) // hanya dikirim jika ada
            }
        });
    }

    getSertifikasi(startDate, endDate) {
        return axios.get(url + '/tr_oss_checklist_raw', {
            params: {
                startDate,
                endDate
            }
        })
    }

    // Jumlah SPT
    getSpt(startDate, endDate) {
        return axios.get(url + '/count_oss_checklist_with_spt', {
            params: {
                startDate,
                endDate
            }
        });
    }

    // Jumlah Per Provinsi
    getProvinsi(startDate, endDate) {
        return axios.get(url + '/tr_oss_checklist_propinsi', {
            params: {
                startDate,
                endDate
            }
        })
    }

    // Jumlah Per Provinsi Per Izin
    getProvinsiPerIzin(startDate, endDate, kdIzin) {
        console.log('getProvinsiPerIzin', startDate, endDate, kdIzin);
        return axios.get(url + '/tr_oss_checklist_propinsi_per_izin', {
            params: {
                startDate,
                endDate,
                kdIzin
            }
        })
    }

    getUpi(tahun) {
        return axios.get(url + '/tt_dashboard_upi', {
            params: {
                tahun: tahun
            }
        });
    }

    // Jumlah HACCP
    getSft(tahun) {
        return axios.get(url + '/tt_dashboard_sft', {
            params: {
                tahun: tahun
            }
        })
    };

    // Jumlah UPI Baru
    getUpn(tahun) {
        return axios.get(url + '/tt_dashboard_upn', {
            params: {
                tahun: tahun
            }
        })
    }

    // Tahun Honnest
    getTahunHonest() {
        return axios.get(url + '/years_honnest')
    }

    // Jumlah SKHS
    getSkv() {
        return axios.get(url + '/tt_dashboard_skv')
    }

    // Jumlah frequensi
    getFrequensi(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getfreq/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi negara
    getFrequensiNegara(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefreqctr/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi upt
    getFrequensiUpt(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefrequpt/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah frequensi upt
    getFrequensiTrader(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/gefreqtrd/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Total Frequensi
    getJumlahFrequensi(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getjumfreq/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Total Volume
    getJumlahVolume(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getjumvol/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Jumlah Nilai
    getJumlahNilai(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getnilai/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Bulan Tahun untuk dashboard sementara dibedakan
    getBulanTahun() {
        return axios.get(url + '/getbulantahun')
    }

    // Bulan Tahun untuk report sementara dibedakan
    getBulanTahun2() {
        return axios.get(url + '/getbulantahun2')
    }

    // Nama UPT
    getNamaUPT(kdUpt) {
        return axios.get(url + '/getuptbyid/' + kdUpt)
    }

    // Get Keterangan Bentuk
    getKetBentuk(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getbentuk/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    getKomoditasUnggulan(kdUpt, tglAwal, tglAkhir, limit = 10) {
        const encodedTglAwal = encodeURIComponent(tglAwal);
        const encodedTglAkhir = encodeURIComponent(tglAkhir);
        return axios.get(`${url}/getkomoditasunggulan/${kdUpt}/${encodedTglAwal}/${encodedTglAkhir}?limit=${limit}`);
    }

    // Get Tahunnya
    getTahun() {
        return axios.get(url + '/gettahun')
    }

    // Get Frequensi Bulan
    getFrequensiBulan(kdUpt, tglAwal, tglAkhir) {
        return axios.get(url + '/getfreqbulan/' + kdUpt + '/' + tglAwal + '/' + tglAkhir)
    }

    // Get Report SMKHP dengan parameter kdUpt, page, limit, tanggal awal, tanggal akhir
    getReportSMKHP(kdUpt, page = 1, limit = 10, tglAwal = null, tglAkhir = null) {
        return axios.get(`${url}/tr-report-ekspor/${kdUpt}`, {
            params: {
                page,
                limit,
                ...(tglAwal && tglAkhir && {
                    tglAwal,
                    tglAkhir
                })
            }
        });
    }

    getExcell(kdUpt, tglAwal = null, tglAkhir = null) {
        return axios.get(`${url}/tr-report-ekspor-excell/${kdUpt}`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    tglAwal,
                    tglAkhir
                })
            },
            responseType: "blob" // Penting agar response dikenali sebagai file
        });
    }

    getReportPBUMKU(tglAwal = null, tglAkhir = null, page = 1, limit = 10, kd_izin = null, kd_daerah_prefix = null) {
        return axios.get(`${url}/primer`, {
            params: {
                page,
                limit,
                ...(tglAwal && tglAkhir && {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                }),
                ...(kd_izin && { kd_izin }),
                ...(kd_daerah_prefix && { kd_daerah_prefix })
            }
        });
    }

    getRekapPrimerPropinsi(tglAwal = null, tglAkhir = null) {
        // return axios.get(`${url}/primer-rekap-izin-by-propinsi`, {
        return axios.get(`${url}/primer-rekap-izin-by-propinsi-by-izin-tabel`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                })
            }
        });
    }

    getRekapPrimerIzin(tglAwal = null, tglAkhir = null, statusChecklist = null) {
        return axios.get(`${url}/primer-rekap-izin-by-kdizin`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                }),
                ...(statusChecklist && {
                    status_checklist: statusChecklist
                })
            }
        });
    }

    //Exsekutif Dashboard
    getGraphPBUMKU(tglAwal, tglAkhir) {
        return axios.get(`${url}/graph-pbumku`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getRekapPBUMKU(tglAwal, tglAkhir) {
        return axios.get(`${url}/rekap-pbumku`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getPropinsiIzin(tglAwal, tglAkhir, limit) {
        return axios.get(`${url}/propinsi-izin`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir,
                }),
                ...(limit && { limit }), // ✅ tambahkan jika limit tersedia
            },
        });
    }
    
    getPropinsiIzinRekap(tglAwal, tglAkhir, limit) {
        return axios.get(`${url}/propinsi-izin-rekap`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir,
                }),
                ...(limit && { limit }), // ✅ tambahkan jika limit tersedia
            },
        });
    }

    getHACCPBulan(tahun) {
        return axios.get(`${url}/haccp-per-bulan`, {
            params: {
                tahun: tahun
            }
        });
    }

    getRekapPermohonan(tglAwal, tglAkhir) {
        return axios.get(`${url}/rekap-pbumku-by-permohonan`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getJumlahHACCP(tglAwal, tglAkhir) {
        return axios.get(`${url}/haccp-per-tahun`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getSKPPerPropinsi(tglAwal, tglAkhir, limit = null) { // Tambahkan parameter 'limit' dengan default null
        const params = {
            ...(tglAwal && tglAkhir && {
                startDate: tglAwal,
                endDate: tglAkhir
            })
        };

        // Tambahkan limit ke params jika tidak null
        if (limit !== null) {
            params.limit = limit;
        }

        return axios.get(`${url}/propinsi-skp`, {
            params: params
        });
    }

    getJumlahTotalPermohonanSKP(tglAwal, tglAkhir) {
        return axios.get(`${url}/total-permohonan-skp`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getJumlahTotalSKPTerbit(tglAwal, tglAkhir) {
        return axios.get(`${url}/total-skp-terbit`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                })
            }
        });
    }

    getReportSKP(tglAwal = null, tglAkhir = null, page = 1, limit = 10, kodePropinsi = null) {
        return axios.get(`${url}/report-skp2`, {
            params: {
                page,
                limit,
                ...(tglAwal && tglAkhir && {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                }),
                ...(kodePropinsi && { kode_propinsi: kodePropinsi })
            }
        });
    }

    getHACCPPerPropinsi(tglAwal, tglAkhir, limit = null) {
        return axios.get(`${url}/haccp-per-propinsi`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                }),
                ...(limit && { limit }) // hanya dikirim jika limit ada
            }
        });
    }

    getHACCPPerPropinsiPerGrade(tglAwal, tglAkhir, limit = null) {
        return axios.get(`${url}/haccp-per-propinsi-per-grade`, {
            params: {
                ...(tglAwal && tglAkhir && {
                    startDate: tglAwal,
                    endDate: tglAkhir
                }),
                ...(limit && { limit }) // hanya dikirim jika limit ada
            }
        });
    }

    /**
     * Mengambil data grouping dari dashboard
     * @param {string} kategori - kategori grouping ('negara', 'upt', 'trader', 'kel_ikan')
     * @param {string} tglAwal - format: 'YYYY-MM-DD'
     * @param {string} tglAkhir - format: 'YYYY-MM-DD'
     * @param {string|null} kdUpt - opsional, filter unit kerja
     * @param {number|null} limit - opsional, batas data
     * @param {string|null} orderBy - opsional, default 'jumlah', bisa juga 'netto' atau 'nilaiIDR'
     */
    getCommonGrouping({ kategori, tglAwal, tglAkhir, kdUpt = null, limit = null, orderBy = null }) {
        return axios.get(`${url}/getcommongrouping`, {
            params: {
                ...(kdUpt && { kdUpt }),
                ...(tglAwal && { tglAwal }),
                ...(tglAkhir && { tglAkhir }),
                ...(kategori && { kategori }),
                ...(limit && { paramLimit: limit }),
                ...(orderBy && { paramOrder: orderBy })
            }
        });
    }

}